export default function Marquee({ items, className = "", speed = "marquee", accent = "text-reactor-red" }) {
  // Repeat the set enough times to always overflow even ultra-wide screens,
  // then duplicate into two identical halves so the -50% loop is seamless.
  const half = [...items, ...items, ...items, ...items];
  const content = [...half, ...half];
  return (
    <div
      className={`relative flex justify-center overflow-hidden border-y border-white/10 bg-void py-4 ${className}`}
      data-testid="editorial-marquee"
    >
      <div className={`flex w-max animate-${speed} whitespace-nowrap will-change-transform`}>
        {content.map((item, i) => (
          <span
            key={i}
            className={`mx-6 flex items-center gap-6 font-mono text-sm uppercase tracking-[0.35em] ${accent}`}
          >
            {item}
            <span className="h-1.5 w-1.5 bg-hazard-amber" aria-hidden />
          </span>
        ))}
      </div>
    </div>
  );
}
